import { GET_REGISTERED_USERS_FOR_PERIOD } from '../actions/actionTypes';


const initialState = {
    registeredUsers: [],

}

export default (state = initialState, action) => {

    switch (action.type) {
        case GET_REGISTERED_USERS_FOR_PERIOD:
            return {
                ...state,
                registeredUsers: action.data
            }
        default:
            return state;
    }
}